/**
 * SiteHeader - site header with navigation and search.
 * Custom element: <site-header>
 *
 * Refs:
 *   [data-ref="menuDrawerTrigger"]  (required)
 *   [data-ref="sideCartTrigger"]  (required)
 *   [data-ref="searchDrawerTrigger"]  (required)
 *   [data-ref="wishListIconCount"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-DrawerContainer.js";
import "./component-IconCount.js";
import { ThemeComponent, cart } from "./theme.js";
import { isNumber } from "./vendor.js";
import "./component-DrawerHeader.js";
import "./component-BodyOverlay.js";
class SiteHeader extends ThemeComponent {
  constructor() {
    super(...arguments), this.menuDrawer = null, this.menuDrawerIsActive = !1, this.searchDrawer = null, this.sideCartDrawer = null, this.cartCount = null, this.siteHeaderWrapper = null, this.wishListCount = null;
  }
  init() {
    this.menuDrawer = document.querySelector(".drawer-container--mobile-menu"), this.searchDrawer = document.querySelector(".drawer-container--mobile-search"), this.sideCartDrawer = document.querySelector(".drawer-container--side-cart"), this.cartCount = [...this.querySelectorAll(".site-header__count")], this.siteHeaderWrapper = document.querySelector(".site-header-wrapper"), this.handleBodyPadding(), new ResizeObserver(() => {
      this.handleBodyPadding();
    }).observe(this), this.listenForMenuDrawerTriggerClicks(), this.listenForSearchDrawerTriggerClicks(), this.listenForSideCartTriggerClick(), this.$subscribe(cart.onChange, () => this.updateItemCount());
    const desktopMediaQuery = window.matchMedia("(min-width: 1024px)");
    desktopMediaQuery.onchange = mediaChangeEvent => {
      if (mediaChangeEvent.matches) for (const drawerTrigger of this.menuDrawerTrigger) this.closeDrawer(drawerTrigger);
    }, this.swymCallbacks();
  }
  swymCallbacks() {
    const onSwymLoadCallback = setFunctionName(swym => {
      if (swym) {
        let onSuccess = setFunctionName(wishLists => {
            let totalCount = null,
              runningCount = 0;
            wishLists.map(wishList => {
              totalCount = wishList.listcontents.length + runningCount, runningCount = totalCount;
            }), this.wishListCount = totalCount, totalCount != null && totalCount > 0 && this.updateWishListCount(totalCount);
          }, "onSuccess"),
          onError = setFunctionName(function (swymError) {
            console.log("Error while fetching List details", swymError);
          }, "onError");
        swym.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        }), this.listenForWishListAddRemove(swym);
      }
    }, "onSwymLoadCallback");
    window.SwymCallbacks || (window.SwymCallbacks = []), window.SwymCallbacks.push(onSwymLoadCallback);
  }
  listenForWishListAddRemove(swymApi) {
    let wishListListener = setFunctionName(swymEvent => {
      swymEvent.type == "sw:removedfromwishlist" && isNumber(this.wishListCount) && this.updateWishListCount(this.wishListCount - 1), swymEvent.type == "sw:addedtowishlist" && isNumber(this.wishListCount) && this.updateWishListCount(this.wishListCount + 1);
    }, "listener");
    swymApi.evtLayer.addEventListener("sw:addedtowishlist", wishListListener), swymApi.evtLayer.addEventListener("sw:removedfromwishlist", wishListListener);
  }
  updateWishListCount(newCount) {
    this.wishListIconCount && (this.wishListCount = newCount, this.wishListIconCount.innerHTML = `${newCount}`, newCount > 0 ? this.wishListIconCount.classList.remove("visibility-hidden") : this.wishListIconCount.classList.add("visibility-hidden"));
  }
  handleBodyPadding() {
    var wrapperHeight;
    const headerHeight = (wrapperHeight = this.siteHeaderWrapper) == null ? void 0 : wrapperHeight.offsetHeight;
    headerHeight && document.body.style.setProperty("--site-header-height", `${headerHeight}px`);
  }
  listenForMenuDrawerTriggerClicks() {
    for (const menuTrigger of this.menuDrawerTrigger) this.$listen(menuTrigger, "click", () => {
      this.menuDrawerIsActive ? this.closeDrawer(menuTrigger) : this.openDrawer(menuTrigger);
    });
  }
  closeDrawer(triggerToClose) {
    var drawerForClose;
    (drawerForClose = this.menuDrawer) == null || drawerForClose.close(), this.menuDrawerIsActive = !1, triggerToClose.classList.remove("is-active");
  }
  openDrawer(triggerToOpen) {
    var drawerForOpen;
    (drawerForOpen = this.menuDrawer) == null || drawerForOpen.open(), this.menuDrawerIsActive = !0, triggerToOpen.classList.add("is-active");
  }
  listenForSearchDrawerTriggerClicks() {
    this.$listen(this.searchDrawerTrigger, "click", () => {
      var searchDrawerForOpen;
      (searchDrawerForOpen = this.searchDrawer) == null || searchDrawerForOpen.open();
    });
  }
  listenForSideCartTriggerClick() {
    for (const sideCartTriggerElement of this.sideCartTrigger) this.$listen(sideCartTriggerElement, "click", sideCartClickEvent => {
      var sideCartForOpen;
      (sideCartForOpen = this.sideCartDrawer) == null || sideCartForOpen.open();
    });
  }
  updateItemCount() {
    if (this.cartCount) {
      const itemCount = cart.getCartItemCount();
      for (const countBadge of this.cartCount) countBadge.updateCount(String(itemCount));
    }
  }
}
setFunctionName(SiteHeader, "SiteHeader");
const propertyTypes = {};
SiteHeader.prototype.$name = "SiteHeader";
SiteHeader.prototype.$info = JSON.parse('{"name":"SiteHeader","meta":{"isLegacy":false,"selector":"site-header"},"props":[],"refs":[{"selector":"[data-ref=\\"menuDrawerTrigger\\"]","required":true,"propertyKey":"menuDrawerTrigger","propertyType":"Array","propertyTypeName":"Array","propertyTsTypeName":"HTMLElement[]"},{"selector":"[data-ref=\\"sideCartTrigger\\"]","required":true,"propertyKey":"sideCartTrigger","propertyType":"Array","propertyTypeName":"Array","propertyTsTypeName":"HTMLButtonElement[]"},{"selector":"[data-ref=\\"searchDrawerTrigger\\"]","required":true,"propertyKey":"searchDrawerTrigger","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"},{"selector":"[data-ref=\\"wishListIconCount\\"]","required":false,"propertyKey":"wishListIconCount","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLSpanElement"}]}');
SiteHeader.prototype.$info.component = SiteHeader;
for (const prop of SiteHeader.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("SiteHeader/SiteHeader.ts", {
  SiteHeader: SiteHeader
}, void 0);